export enum Theme {
    auto = 'auto',
    light = 'light',
    dark = 'dark',
}

export type RenderableTheme = Theme.light | Theme.dark;
